"use client"
import urlList, { redirectToSocial } from "@/urlList"
import { useState, useEffect } from "react"
import "./Footer.css"
import "./Footer.revamp.css"
import { FaFacebook, FaLinkedin, FaYoutube } from "react-icons/fa"
import { useRouter } from "next/navigation"
import { FaSquareXTwitter, FaInstagram } from "react-icons/fa6"
import axios from "axios"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSquareFacebook, faLinkedin, faSquareInstagram, faSquareYoutube } from "@fortawesome/free-brands-svg-icons"

type Microsite = {
  id: number
  microsite: string
  name: string
}

const sprintVersion = "1.0.0" // Replace with your actual version

export default function FooterComponent() {
  const router = useRouter()
  const [microsites, setMicrosites] = useState<Microsite[]>([])
  const currentYear = new Date().getFullYear()
  
  useEffect(() => {
    const fetchMicrosites = async () => {
      try {
        const response = await axios.get(urlList.GET_PUBLISHED_BUSINESS_VERTICAL)
        const data = response.data
        if (data?.data && Array.isArray(data.data)) {
          setMicrosites(
            data.data.map((item: any) => ({
              id: item.id,
              microsite: item.microsite,
              name: item.name,
            })),
          )
        }
      } catch {
        setMicrosites([])
      }
    }
    fetchMicrosites()
  }, [])

  const navigateToLink = (path: string) => {
    router.push(path)
  }

  const redirectTo = (url: string) => {
    window.open(url, "_blank")
  }

  const routeToOodlesTec = () => {
    window.open("https://www.oodlestechnologies.com/", "_blank")
  }

  // ── OLD IMPLEMENTATION (commented out — preserved for reference) ──────────
  // return (
  //   <div
  //     className={`footer3 mx-0${router && (typeof window !== "undefined" && (window.location.pathname === "/" || window.location.hash)) ? " newFooter" : ""}`}
  //     id="footer"
  //   >
  //     {/* Desktop Layout */}
  //     <div className="hidden md:block">
  //       <div className="col-md-7 px-md-3 px-0 row py-4 mx-auto">
  //         <div className="w-20">
  //           <p className="heading">Valued Services</p>
  //           {microsites.map((microsite, i) => (
  //             <a
  //               className="cursor"
  //               href={`${microsite.microsite}?utm_source=oodles.com`}
  //               target="_blank"
  //               rel="noopener noreferrer"
  //               key={i}
  //             >
  //               {microsite.name}
  //             </a>
  //           ))}
  //         </div>
  //         <div className="w-20">
  //           <p className="heading">LEGAL</p>
  //           <a className="cursor" onClick={() => navigateToLink("/privacy-policy")}>
  //             Privacy Policy
  //           </a>
  //           <a className="cursor" onClick={() => navigateToLink("/terms-and-conditions")}>
  //             Terms & Conditions
  //           </a>
  //           <a className="cursor" onClick={() => navigateToLink("/cookie-policy")}>
  //             Cookie Policy
  //           </a>
  //         </div>
  //         <div className="w-20">
  //           <p className="heading">INFO</p>
  //           <a className="cursor" onClick={() => navigateToLink("/onoarding")}>
  //             Contact Us
  //           </a>
  //           <a className="cursor" href="https://careers.oodles.io/" target="_blank" rel="noopener noreferrer">
  //             Careers
  //           </a>
  //         </div>
  //       </div>
  //     </div>
  //
  //     {/* Mobile Layout */}
  //     <div className="block md:hidden px-4 py-4">
  //       <div className="grid grid-cols-2 gap-6">
  //         {/* First Column: Valued Services */}
  //         <div className="mobile-section">
  //           <p className="heading">Valued Services</p>
  //           {microsites.map((microsite, i) => (
  //             <a
  //               className="cursor mobile-link"
  //               href={`${microsite.microsite}?utm_source=oodles.com`}
  //               target="_blank"
  //               rel="noopener noreferrer"
  //               key={i}
  //             >
  //               {microsite.name}
  //             </a>
  //           ))}
  //         </div>
  //         {/* Second Column: Legal and Info */}
  //         <div className="mobile-section">
  //           <p className="heading">LEGAL</p>
  //           <a className="cursor mobile-link" onClick={() => navigateToLink("/privacy-policy")}>
  //             Privacy Policy
  //           </a>
  //           <a className="cursor mobile-link" onClick={() => navigateToLink("/terms-and-conditions")}>
  //             Terms & Conditions
  //           </a>
  //           <a className="cursor mobile-link" onClick={() => navigateToLink("/cookie-policy")}>
  //             Cookie Policy
  //           </a>
  //           <p className="heading">INFO</p>
  //           <a className="cursor mobile-link" onClick={() => navigateToLink("/onoarding")}>
  //             Contact Us
  //           </a>
  //           <a
  //             className="cursor mobile-link"
  //             href="https://careers.oodles.io/"
  //             target="_blank"
  //             rel="noopener noreferrer"
  //           >
  //             Careers
  //           </a>
  //         </div>
  //       </div>
  //     </div>
  //
  //     <hr className="my-2 border-gray-300 hidden md:block" />
  //
  //     {/* Social Media Links - Responsive */}
  //     <div className="flex flex-col md:flex-row items-center w-full p-2">
  //       <div className="flex flex-row items-center gap-3 md:w-1/3 justify-start md:mb-3 md:mb-0 w-full">
  //         <FaFacebook className="cursor-pointer text-lg" onClick={() => redirectToSocial("facebook")} />
  //         <FaLinkedin className="cursor-pointer text-lg" onClick={() => redirectToSocial("linkedin")} />
  //         <FaSquareXTwitter
  //           className="cursor-pointer text-lg"
  //           style={{ width: 17, height: 17 }}
  //           onClick={() => redirectToSocial("twitter")}
  //         />
  //         <FaInstagram className="cursor-pointer text-lg" onClick={() => redirectToSocial("instagram")} />
  //         <FaYoutube className="cursor-pointer text-lg" onClick={() => redirectToSocial("youtube")} />
  //       </div>
  //
  //       <hr className="my-2 border-gray-300 block md:hidden w-[90%]" />
  //
  //       <div className="md:w-2/3 text-center md:text-right md:mb-3">
  //         <span className="copyRightText">
  //           V{sprintVersion}&nbsp;&nbsp; &#9679;&nbsp;&nbsp;Copyright 2009-2025&nbsp;
  //           <a className="linkToOodles cursor" onClick={routeToOodlesTec}>
  //             Oodles Technologies
  //           </a>
  //         </span>
  //       </div>
  //     </div>
  //   </div>
  // )
  // ── END OLD IMPLEMENTATION ──────────────────────────────────────────────────

  // ── NEW IMPLEMENTATION (revamp — mirrors repo1 footer design) ──────────────
  return (
    <div
      className={`footer3-rev section-padding${typeof window !== "undefined" && (window.location.pathname === "/" || !!window.location.hash) ? " newFooter" : ""}`}
      id="footer"
    >
      {/* Main two-column row: logo+description | nav menus */}
      <div className="footer-rev-row">
        {/* Left: Logo + Description */}
        <div className="footer-rev-col-left">
          <div className="footer-left">
            <a href="/" className="footer-logo">
              <img
                src="https://d2a2ewayv7zdze.cloudfront.net/oodles-static-asset/footer-logo.svg"
                alt="Oodles Logo"
              />
            </a>
            <h4 className="ds-body ff-inter-regular ds-fw-400">
              Oodles Technologies enables organizations to build, scale, and optimize digital ecosystems through
              specialized engineering talent and advanced technology solutions.
            </h4>
          </div>
        </div>

        {/* Right: Nav Menus */}
        <div className="footer-rev-col-right">
          <div className="footer-right">
            {/* Valued Services */}
            <div className="footer-rev-menus">
              <p className="ds-para ds-color-primary ff-plus-bold">Valued Services</p>
              {microsites.map((site, i) =>
                site.id === 2 || site.microsite === 'https://blockchain.oodles.io/' ? (
                  <a
                    key={i}
                    className="rev-microsite ds-para ff-inter-regular ds-fw-400 cursor"
                    href="https://www.oodles.com/healthcare-it/7144785"
                    target="_self"
                  >
                    {site.name}
                  </a>
                ) : (
                  <a
                    key={i}
                    className="rev-microsite ds-para ff-inter-regular ds-fw-400 cursor"
                    href={`${site.microsite}?utm_source=oodles.com`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {site.name}
                  </a>
                )
              )}
            </div>

            {/* Legal */}
            <div className="footer-rev-menus">
              <p className="ds-para ds-color-primary ff-plus-bold">Legal</p>
              <a className="rev-microsite ds-para ff-inter-regular ds-fw-400 cursor" onClick={() => navigateToLink("/privacy-policy")}>
                Privacy Policy
              </a>
              <a className="rev-microsite ds-para ff-inter-regular ds-fw-400 cursor" onClick={() => navigateToLink("/terms-and-conditions")}>
                Terms &amp; Conditions
              </a>
              <a className="rev-microsite ds-para ff-inter-regular ds-fw-400 cursor" onClick={() => navigateToLink("/cookie-policy")}>
                Cookie Policy
              </a>
            </div>

            {/* Info */}
            <div className="footer-rev-menus">
              <p className="ds-para ds-color-primary ff-plus-bold">Info</p>
              <a className="rev-microsite ds-para ff-inter-regular ds-fw-400 cursor" onClick={() => navigateToLink("/contact-us")}>
                Contact Us
              </a>
              <a
                className="rev-microsite ds-para ff-inter-regular ds-fw-400 cursor"
                href="https://careers.oodles.io/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Careers
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Separator */}
      <div className="seperator"></div>

      {/* Bottom: Social icons + Copyright */}
      <div className="footer-bottom">
        <div className="social-container">
          <div className="social-icon cursor" role="button" tabIndex={0} onClick={() => redirectToSocial("facebook")}>
            <FontAwesomeIcon icon={faSquareFacebook} />
          </div>
          <div className="social-icon cursor" role="button" tabIndex={0} onClick={() => redirectToSocial("linkedin")}>
            <FontAwesomeIcon icon={faLinkedin} />
          </div>
          <div className="social-icon cursor" role="button" tabIndex={0} onClick={() => redirectToSocial("twitter")}>
            <img src="/icon/x-logo.svg" alt="twitter-logo" />
          </div>
          <div className="social-icon cursor" role="button" tabIndex={0} onClick={() => redirectToSocial("instagram")}>
            <FontAwesomeIcon icon={faSquareInstagram} />
          </div>
          <div className="social-icon cursor" role="button" tabIndex={0} onClick={() => redirectToSocial("youtube")}>
            <FontAwesomeIcon icon={faSquareYoutube} />
          </div>
        </div>

        <div className="copyrightBox">
          <p className="ds-para ds-fw-500 ff-plus-medium ds-gray-500">
            © Copyright 2009-{currentYear}{" "}
            <a onClick={routeToOodlesTec}>Oodles Technologies</a>. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  )
  // ── END NEW IMPLEMENTATION ──────────────────────────────────────────────────
}
